// Der Modellkatalog lebt in der Datenbank (Collection chat_model_settings,
// siehe manta/modelSettings.ts) und wird von Systemadmins im
// Einstellungsbereich gepflegt. DEFAULT_MODEL_CATALOG ist nur noch der
// Seed-Bestand, der beim Start von chat-api idempotent angelegt wird
// (ModelCatalogRepository.seedDefaults) — Quelle der Wahrheit ist die DB.
//
// Exakte IONOS-Modell-IDs, siehe docs/chat-app/SPIKE.md.
// Bedrock-Modell-IDs tragen den `anthropic.`-Präfix (siehe AWS-Doku zu Amazon
// Bedrock). Nicht-Anthropic-Bedrock-Modelle (Mistral, Amazon Nova) laufen über
// die Converse-API (Provider `bedrock-converse`), da der Anthropic-Client nur
// Claude-Modelle bedient.

// Modell-IDs sind seit der DB-Verwaltung freie Strings — Gültigkeit prüft die
// Anwendung zur Laufzeit gegen den Katalog (ModelCatalogRepository.get).
export type ModelId = string

export const MODEL_PROVIDERS = ['ionos', 'bedrock', 'bedrock-converse'] as const
export type ModelProvider = (typeof MODEL_PROVIDERS)[number]

export type ModelInfo = {
  id: ModelId
  label: string
  reasoning: boolean
  provider: ModelProvider
  // Modell ist in Bedrock nur über Cross-Region-Inference-Profile aufrufbar —
  // die Converse-API braucht dann einen Geo-Präfix (`us.`/`eu.`/`apac.`),
  // der zur AWS_REGION passt und zur Laufzeit vorangestellt wird.
  inferenceProfile?: boolean
}

export const DEFAULT_MODEL_CATALOG: ReadonlyArray<ModelInfo> = [
  { id: 'openai/gpt-oss-120b', label: 'GPT-OSS 120B', reasoning: true, provider: 'ionos' },
  {
    id: 'meta-llama/Meta-Llama-3.1-405B-Instruct-FP8',
    label: 'Llama 3.1 405B Instruct',
    reasoning: false,
    provider: 'ionos',
  },
  {
    id: 'anthropic.claude-sonnet-5',
    label: 'Claude Sonnet 5',
    reasoning: true,
    provider: 'bedrock',
  },
  {
    id: 'anthropic.claude-opus-4-8',
    label: 'Claude Opus 4.8',
    reasoning: true,
    provider: 'bedrock',
  },
  {
    id: 'mistral.devstral-2-123b',
    label: 'Devstral 2 123B',
    reasoning: false,
    provider: 'bedrock-converse',
  },
  {
    id: 'mistral.pixtral-large-2502-v1:0',
    label: 'Pixtral Large (25.02)',
    reasoning: false,
    provider: 'bedrock-converse',
    inferenceProfile: true,
  },
  {
    id: 'amazon.nova-2-lite-v1:0',
    label: 'Nova 2 Lite',
    reasoning: true,
    provider: 'bedrock-converse',
    inferenceProfile: true,
  },
  {
    id: 'amazon.nova-pro-v1:0',
    label: 'Nova Pro',
    reasoning: false,
    provider: 'bedrock-converse',
  },
]
